// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @20.11.2018 09:54:00
import { PasswordReturnArgs_abstract } from './../../abstract/SagaBase/Defines/PasswordReturnArgs_abstract';
export class PasswordReturnArgs extends PasswordReturnArgs_abstract {}
